var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exhibition-section"},[_c('div',{ref:"wrapper",staticClass:"exhibition-section__wrapper"},[_c('div',{ref:"content",staticClass:"exhibition-section__content"},[_vm._t("default")],2),(_vm.shimset === 'show')?_c('div',{ref:"shim",staticClass:"exhibition-section__shim"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }